module.exports = __webpack_public_path__ + "./kit/docs/img/code-example-2.7e0eddac20ed75046fec72839d3e26d5.svg";